import React, { Component } from "react";
import { fixTime } from "../../helpers";
import "./ScheduleEntry.css";

import HeaderCard from "./HeaderCard";
import Button from "./Button";

class ScheduleEntry extends Component {
  data = this.props.dataPass;
  day = `${this.props.day}/${this.data.AppointmentID}`;
  path = this.props.path;

  render() {
    return (
      <div className="schedule-class-wrapper">
        <div className="schedule-class">
          <HeaderCard
            headerClass="cyan small day-view"
            headerLabel="Time"
            headerValue={fixTime(this.data.Time)}
          />
          <HeaderCard
            headerClass="green small day-view"
            headerLabel="Appointment Type"
            headerValue={this.data.Appointments}
          />
          <HeaderCard
            headerClass="magenta long day-view"
            headerLabel="Location"
            headerValue={this.data.Location}
          />
          <Button
            buttonValue={this.props.buttonValue}
            day={this.day}
            path={this.path}
            dataPass={this.data}
          />
        </div>
      </div>
    );
  }
}

export default ScheduleEntry;
